"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationService = void 0;
class LocationService {
    matches(currentLocation, checkedLocation) {
        const highestSpecificityTypes = this.filterForHighestSpecificity(currentLocation).map((type) => [...this.decode([type])[0]]);
        return highestSpecificityTypes.some((location) => checkedLocation.startsWith(this.encode([location])[0]));
    }
    matchesSome(currentLocation, checkedLocations) {
        const highestSpecificityTypes = this.filterForHighestSpecificity(currentLocation).map((type) => [...this.decode([type])[0]]);
        return highestSpecificityTypes.some((location) => checkedLocations.some((checkedLocation) => checkedLocation.startsWith(this.encode([location])[0])));
    }
    encode(decoded) {
        return decoded.map((group) => group.join(';'));
    }
    decode(encoded) {
        return encoded.map((item) => item.split(';'));
    }
    filterForHighestSpecificity(types) {
        const decodedTypes = types.map((type) => [...this.decode([type])[0]]);
        return this.encode(decodedTypes.filter((type) => !decodedTypes.some((nestedType) => nestedType[0] === type[0] && type.length < nestedType.length)));
    }
}
exports.LocationService = LocationService;
//# sourceMappingURL=LocationService.js.map